import {ActionType, createAction} from 'typesafe-actions';

export const fileShareSceneDownloadFile = createAction(
    'FILE_SHARE_SCENE_DOWNLOAD_FILE',
    (action) => (fileId: string) => action({fileId})
);

export type FileListingActionTypes = ActionType<typeof fileShareSceneDownloadFile>;
